import { Box, Container, Typography } from "@mui/material";
import React from "react";
import EffectivenessChangeLog from "../components/EffectivenessChangeLog";

const MeasurementChangeLogPage: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 8 }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom fontWeight="700">
                    Measurement change log
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800 }}>
                    Product changes that can move pre → post growth, completion rates, or who is in the measured sample.
                </Typography>
            </Box>
            <EffectivenessChangeLog />
        </Container>
    );
};

export default MeasurementChangeLogPage;
